export default "__VITE_ASSET__CF7$R1Q2__"